












































import { Component, Vue, Prop } from "vue-property-decorator";
import requestStore from "@/store/requestStore";
import { ValidationProvider } from "vee-validate";
import SimpleDialogForm from "@/components/Forms/SimpleDialogForm.vue";
import { Observer } from "mobx-vue";

@Observer
@Component({ components: { ValidationProvider, SimpleDialogForm } })
export default class RequestCancelDialog extends Vue {
  @Prop(Boolean) readonly value: boolean = false;
  @Prop({ default: "" }) dataCy?: string;

  requestStore = requestStore;

  handleCloseDialog() {
    requestStore.resetAddressFound();
    this.$emit("input", false);
  }

  applyAddress() {
    this.$emit("applyFoundAddress");
  }

  destroyed() {
    requestStore.resetAddressFound();
  }
}
